{"version":"26.11.3-local-solo","id":"at.softline.bolay.softline","name":"Hagebau Bolay intern Softline"}